<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>
        <b-row>
            <b-container>
                <h5 class="text-center py-2">
                    <b-row class="mb-4 justify-content-center align-items-center text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.reporte }}:</b></label>
                            <select v-model="dialogReportes" @click="showTblAjuste = false"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="(item, idx) in reportes" :key="'codigo_' + idx" :value="item.codigo">
                                    {{ item.codigo }}-{{ item.nombre }}
                                </option>
                            </select>
                        </b-col>
                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.vigencia }}:</b></label>
                            <select v-model="selVigencia" @click="showTblAjuste = false"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="(item, idx) in listVigencia" :key="'fecha-' + idx"
                                    :value="item.vigencia">
                                    {{ item.vigencia }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>
                </h5>
                <b-row class="mb-4 justify-content-center">
                    <b-col md="12" class="text-center">
                        <b-button @click="consultAjuste()" id="consult-btn" size="lg" variant="outline-primary">
                            <b-icon icon="search" class="me-2"></b-icon>
                            {{ labels.consultar }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <!-- Estado de carga -->
        <b-row v-if="isLoading">
            <b-container class="text-center py-5">
                <b-col md="12">
                    <div class="loading-spinner mb-3">
                        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>
                    <h4 class="text-primary">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </b-col>
            </b-container>
        </b-row>

        <!-- Mensaje cuando no hay datos -->
        <b-row v-if="!isLoading && isEmpty && !showTblAjuste">
            <b-container>
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4" :class="{ active: isEmpty }">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around text-center">
                    <span id="message" v-if="isEmpty" class="h4 text-muted">{{labels.empty}}</span>
                </b-col>
                <b-col md="12" class="mt-3 text-center">
                    <b-button @click="adicionAjuste()" variant="primary" class="btn-add-custom">
                        <b-icon icon="plus-circle" class="me-2"></b-icon>
                        {{ labels.crear }}
                    </b-button>
                </b-col>
            </b-container>
        </b-row>

        <!-- Tabla de ajustes -->
        <b-row v-if="!isLoading && showTblAjuste">
            <b-container class="pb-5">
                <!-- Botón Adicionar cuando hay datos -->
                <b-row class="mb-3" v-if="fglAdicionar">
                    <b-col md="12" class="text-end">
                        <b-button @click="adicionAjuste()" variant="primary" class="btn-add-custom">
                            <b-icon icon="plus-circle" class="me-2"></b-icon>
                            {{ labels.crear }}
                        </b-button>
                    </b-col>
                </b-row>

                <md-table v-model="ajustes" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }" key="principal-table">

                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ labels.title }}</i></b></h1>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }"
                        :class="{ 'clickable-row': true, 'selected-row': selectedRow === item.secuencia }"
                        @click="handleRowClick(item)">
                        <md-table-cell :md-label="labels.secuencia" class="text-center border number-cell">
                            {{ item.secuencia }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_ajuste" class="text-left border descripcion-cell">
                            {{ tipoAjuste(item.tipo_ajuste) }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.origen_nombre" class="text-left border descripcion-cell">
                            {{ item.origen_nombre }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_origen" class="text-left border descripcion-cell">
                            {{ item.tipo_origen }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.destino_nombre" class="text-left border descripcion-cell">
                            {{ item.destino_nombre }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.tipo_destino" class="text-left border descripcion-cell">
                            {{ item.tipo_destino }}
                        </md-table-cell>
                        <md-table-cell :md-label="labels.eliminar" class="text-center border action-cell">
                            <md-button @click.stop="borraAjuste(item.secuencia)"
                                class="md-icon-button md-accent delete-btn-minimal">
                                <md-icon class="delete-icon">delete_outline</md-icon>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>

                <div class="text-center mt-3" v-if="selectedRow">
                    <div class="alert alert-info d-inline-block">
                        <strong>Fila seleccionada:</strong> Secuencia {{ selectedRow }}.
                        Haga clic en otra fila para cambiar la selección.
                    </div>
                </div>

                <div class="col-md-12 mt-4" v-if="showInfoAjuste">
                    <AjustesOrigen :ajustOrigen.sync="ajusteOrig" :codReporte="dialogReportes"
                        :id_compania="ajusteOrig[0].id_compania" :vigencia="selVigencia"
                        :nombreCompania="nombreCompaniaOrigen" />
                </div>
                <div class="col-md-12 mt-4" v-if="ajusteDesti.length > 0">
                    <AjustesDestino :ajustDestino="ajusteDesti" :codReporte="dialogReportes"
                        :id_compania="ajusteDesti[0].id_compania" :vigencia="selVigencia"
                        :nombreCompania="nombreCompaniaDestino" />
                </div>
            </b-container>
        </b-row>

        <NewAjuste :showNewAjuste="showNewAjuste" :vigenciaSelect="selVigencia" :codReporte="dialogReportes"
            @reloadTbl="refrescaTbl" @closeModal="cierraModal" />
    </div>
</template>

<script>
import Balance from '../../services/BalanceNiif'
import PlanCuentas from '../../services/PlanCuentas'
import Ajustes from '../../services/AjustesConsol'
import NewAjuste from './NewAjuste.vue'
import AjustesOrigen from './AjustesOrigen.vue'
import AjustesConsol from '../../services/AjustesConsol'
import AjustesDestino from './AjustesDestino.vue'

export default {
    name:"AjustesConsol",
    components:{
        NewAjuste,
        AjustesOrigen,
        AjustesDestino
    },
    data:() => ({
        isEmpty : false,
        fglAdicionar : false,
        showTblAjuste : false,
        selVigencia : "",
        dialogReportes: "",
        reportes : [],
        listVigencia : [],
        ajustes : [],
        ajusteOrig: [],
        ajusteDesti: [],
        showNewAjuste: false,
        showInfoAjuste: false,
        generado: false,
        selectedRow: null,
        isLoading: false,
        nombreCompaniaOrigen: '',
        nombreCompaniaDestino: '',
    }),
    computed: {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Ajustes de consolidación",
                    titler : "Reclasificacion de Saldos",
                    consultar : "CONSULTAR",
                    vigencia : "Vigencia",
                    reporte : "Reporte",
                    empty : "No hay registros.",
                    crear: "Crear Ajuste",
                    titleTbl : "Ajustes",
                    secuencia : "Secuencia",
                    tipo_ajuste : "Tipo ajuste",
                    origen_nombre : "Empresa",
                    tipo_origen : "Tipo",
                    destino_nombre : "Empresa",
                    tipo_destino : "Tipo",
                    information : "Información",
                    eliminar : "Eliminar"
                }  
            }else{
                return {
                    title : "Consolidation adjustments",
                    titlear : "Balance Reeclassification",
                    consultar : "CONSULT",
                    vigencia : "Validity",
                    reporte : "Report",
                    empty : "Thre is not row",
                    crear: "Create Adjustment",
                    titleTbl : "Adjustments",
                    secuencia : "Sequence",
                    tipo_ajuste : "Setting type",
                    origen_nombre : "Company",
                    tipo_origen : "Type",
                    destino_nombre : "Company",
                    tipo_destino : "Type",
                    information : "Information",
                    eliminar : "Delete"
                }                
            }
        }
    },
    methods:{
        consultAjuste(){
            if (!this.dialogReportes || !this.selVigencia) {
                this.$toast.error('Debe seleccionar reporte y vigencia primero');
                return;
            }

            this.isLoading = true;
            this.showTblAjuste = false;
            this.isEmpty = false;

            Ajustes.getAjustesConsol(this.dialogReportes,this.selVigencia)
            .then((result) => {
                this.ajustes = result.data.ajustes;
                if (this.ajustes.length != 0) {
                    this.isEmpty = false;
                    this.showTblAjuste = true;
                    this.fglAdicionar = true;
                    this.showInfoAjuste = false;
                    this.selectedRow = null;
                } else {
                    this.isEmpty = true;
                    this.showTblAjuste = false;
                    this.showInfoAjuste = false;
                    this.fglAdicionar = false;
                    this.selectedRow = null;
                }
            })
            .catch(() => {
                this.error = true;
                this.$toast.error('Error al consultar los ajustes');
            })
            .finally(() => {
                this.isLoading = false;
            });
        },

        tipoAjuste(tipoAjus){
            if(tipoAjus == 1){
                return 'Interes no controlante';
            }else if(tipoAjus == 2){
                return 'Eliminación en inversión';
            }else if(tipoAjus == 3){
                return 'Eliminación saldo recíproco';
            }else if(tipoAjus == 4){
                return 'Ajuste del Combinado';
            }
            return 'Tipo desconocido';
        },

        handleRowClick(item) {
            this.selectedRow = item.secuencia;
            this.infoAjuste(item.secuencia, item.origen);
        },

        adicionAjuste(){
            if (!this.dialogReportes || !this.selVigencia) {
                this.$toast.error('Debe seleccionar reporte y vigencia primero');
                return;
            }
            this.showNewAjuste = true;
            this.showInfoAjuste = false;
            this.selectedRow = null;
        },

        refrescaTbl(codReporte,vigencia){
            this.isLoading = true;
            Ajustes.getAjustesConsol(codReporte,vigencia)
            .then((result) => {
                this.ajustes = result.data.ajustes;
                this.showNewAjuste = false;
                this.showInfoAjuste = false;
                this.selectedRow = null;
            })
            .catch(() => {
                this.error = true;
                this.$toast.error('Error al refrescar la tabla');
            })
            .finally(() => {
                this.isLoading = false;
            });
        },

        cierraModal(val) {
            this.showNewAjuste = val;
        },

        async infoAjuste(id, idCompOrig) {
            try {
                this.isLoading = true;
                console.log('=== INICIANDO infoAjuste ===');

                // 1. Obtener ajustes origen
                let ajusteOrig = await AjustesConsol.consulAjusteOrigen(id, this.selVigencia, idCompOrig,this.dialogReportes);
                this.ajusteOrig = ajusteOrig.data.ajustOrig;
                console.log('Ajustes origen obtenidos:', this.ajusteOrig);
                console.log('ID compañía origen:', idCompOrig);

                // 2. Obtener ajustes destino
                let ajusteDest = await AjustesConsol.consulAjusteDestino(id, this.selVigencia,this.dialogReportes);
                this.ajusteDesti = ajusteDest.data.ajustDest;
                console.log('Ajustes destino obtenidos:', this.ajusteDesti);

                // 3. OBTENER NOMBRES DE LAS COMPAÑÍAS - ESTO ES LO NUEVO
                console.log('Obteniendo nombre compañía origen...');
                this.nombreCompaniaOrigen = await this.obtenerNombreCompania(idCompOrig);
                console.log('Nombre compañía origen obtenido:', this.nombreCompaniaOrigen);

                if (this.ajusteDesti.length > 0) {
                    console.log('Obteniendo nombre compañía destino...');
                    const idCompDest = this.ajusteDesti[0].id_compania;
                    this.nombreCompaniaDestino = await this.obtenerNombreCompania(idCompDest);
                    console.log('Nombre compañía destino obtenido:', this.nombreCompaniaDestino);
                } else {
                    this.nombreCompaniaDestino = '';
                }

                console.log('Nombres finales:', {
                    origen: this.nombreCompaniaOrigen,
                    destino: this.nombreCompaniaDestino
                });

                this.showInfoAjuste = true;
            } catch (error) {
                console.error('Error en infoAjuste:', error);
                this.$toast.error('Error al cargar la información del ajuste');
            } finally {
                this.isLoading = false;
            }
        },

        // Método para obtener nombre de compañía
        async obtenerNombreCompania(idCompania) {
            try {
                const response = await AjustesConsol.getCompanyName(idCompania);
                return response.data.nombre || `Compañía ${idCompania}`;
            } catch (error) {
                console.error('Error al obtener nombre de compañía:', error);
                return `Compañía ${idCompania}`;
            }
        },


        async borraAjuste(secuencia){
            if (!confirm('¿Está seguro de que desea eliminar este ajuste?')) {
                return;
            }

            this.isLoading = true;
            Ajustes.borraAjuste(this.selVigencia,secuencia)
            .then((res) =>{
                if (res.status == 200) {
                    this.$toast.success(res.status+" Eliminacion "+res.data.message);
                    this.refrescaTbl(this.dialogReportes,this.selVigencia);
                } else {
                    this.$toast.error("error "+ res.status+" al Eliminar");
                }
            })
            .catch((err) => {
                console.log(err);
                this.$toast.error('Error al eliminar el ajuste');
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
    },
    mounted(){
        this.isLoading = true;
        PlanCuentas.getVigenciaPlancuentas()
        .then((result) => {
            this.listVigencia = result.data.getVigencia;
        })
        .catch((err) => {
            console.log(err);
            this.$toast.error('Error al cargar las vigencias');
        })
        .finally(() => {
            this.isLoading = false;
        });

        Balance.getReportes()
        .then ((result) => {
            this.reportes = result.data.reportes;
        })
        .catch(() => {
            this.error = true;
            this.$toast.error('Error al cargar los reportes');
        });
    }
}
</script>

<style scoped>
.balance-table {
    font-size: 14px;
    width: 100% !important;
}

.balance-table>>>.md-table-head {
    padding: 6px 4px !important;
}

.balance-table>>>.md-table-cell {
    padding: 6px 4px !important;
    min-width: auto !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
}

.principal-table>>>.md-table {
    width: 100% !important;
    table-layout: auto !important;
}

.principal-table>>>.md-table-cell {
    width: auto !important;
    max-width: none !important;
}

.balance-table>>>.md-table-toolbar {
    min-height: 50px !important;
    padding: 6px 12px !important;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.clickable-row:hover {
    background-color: #f5f5f5 !important;
}

.selected-row {
    background-color: #e8f4fd !important;
    border-left: 3px solid #2c5f7a !important;
}

.border {
    border: 1px solid #dee2e6 !important;
}

.principal-table>>>.md-table-row {
    transition: all 0.2s ease;
}

.principal-table>>>.md-table-row:hover {
    background-color: #f5f5f5 !important;
}

.btn-edit {
    min-width: 40px !important;
    height: 32px !important;
    margin: 0 !important;
    padding: 0 !important;
}

.btn-edit .md-icon {
    font-size: 16px !important;
}

.principal-table >>> .md-table-cell {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    max-width: 200px !important;
}

.success-svg {
    text-align: center;
}

.success-svg img {
    width: 80px;
    height: 80px;
}

.btn-add-custom {
    background: linear-gradient(135deg, #2e507a 0%, #3a6496 100%);
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    font-size: 1.1rem;
    box-shadow: 0 4px 12px rgba(46, 80, 122, 0.3);
    transition: all 0.3s ease;
}

.btn-add-custom:hover {
    background: linear-gradient(135deg, #3a6496 0%, #4a7bb4 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(46, 80, 122, 0.4);
}

.btn-add-custom:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(46, 80, 122, 0.3);
}

/* Estilos para el estado de carga */
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-spinner .spinner-border {
    width: 3rem;
    height: 3rem;
}
/* Estilos para el botón de eliminar minimalista - tamaño aumentado */
.delete-btn-minimal {
    min-width: 40px !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 6px !important;
    background-color: transparent !important;
    transition: all 0.2s ease !important;
}

.delete-btn-minimal:hover {
    background-color: rgba(244, 67, 54, 0.1) !important;
}

.delete-btn-minimal:active {
    background-color: rgba(244, 67, 54, 0.2) !important;
}

.delete-icon {
    color: #f44336 !important;
    font-size: 24px !important; /* Icono más grande */
    transition: transform 0.2s ease !important;
}

.delete-btn-minimal:hover .delete-icon {
    transform: scale(1.1);
    color: #d32f2f !important;
}
</style>
